// extracted by mini-css-extract-plugin
export var blogMainCard = "article-module--blogMainCard--1x-rC";
export var publisher = "article-module--publisher--pqTs5";
export var readmore = "article-module--readmore--3-E4o";